import { RootStore } from "reducers";

export const documentGenerationEnabled = (state: RootStore) => state?.user?.organization?.document_generation_enabled;
export const userRole = (state: RootStore) => state?.user?.role;

export const isUserAdmin = (state: RootStore) => ["superadmin", "admin"].includes(userRole(state));
export const isFromMcCuneOrg = (state: RootStore) => state?.user?.organization?.id === 100 || state?.user?.organization?.id === 341 || state?.user?.organization?.id === 1; // GD-600

